module.exports = __webpack_public_path__ + "img/swift-boostergreen-glx-azul-tormenta.784cc286.png";